var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholderChallengeBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 60,
    viewBox: "0 0 87 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08305 33.8716L30.0882 15.038M31.5 15.1217L49.1837 35.1246M57.8955 28.6487L30.4104 52.5489M57.9117 28.6534L78.415 46.9848M6 59H81C83.7614 59 86 56.742 86 53.9565V6.04348C86 3.25804 83.7614 1 81 1H6C3.23858 1 1 3.25804 1 6.04348V53.9565C1 56.742 3.23858 59 6 59ZM12.5 53.9565H75C77.7614 53.9565 80 51.6985 80 48.913V11.087C80 8.30152 77.7614 6.04348 75 6.04348H12.5C9.73858 6.04348 7.5 8.30152 7.5 11.087V48.913C7.5 51.6985 9.73857 53.9565 12.5 53.9565ZM77 14.113C77 16.6199 74.9853 18.6522 72.5 18.6522C70.0147 18.6522 68 16.6199 68 14.113C68 11.6062 70.0147 9.57391 72.5 9.57391C74.9853 9.57391 77 11.6062 77 14.113ZM32 14.3652C32 14.783 31.4404 15.1217 30.75 15.1217C30.0596 15.1217 29.5 14.783 29.5 14.3652C29.5 13.9474 30.0596 13.6087 30.75 13.6087C31.4404 13.6087 32 13.9474 32 14.3652Z",
    stroke: "#918F8F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderChallengeBanner);
export default __webpack_public_path__ + "static/media/placeholderChallengeBanner.b099174eba241870e1374b791a5633af.svg";
export { ForwardRef as ReactComponent };